module.exports = __webpack_public_path__ + "img/yampiv2.c89372b1.svg";